import { render, staticRenderFns } from "./PacPhoneInput.vue?vue&type=template&id=6450a077"
import script from "./PacPhoneInput.vue?vue&type=script&lang=js"
export * from "./PacPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./PacPhoneInput.vue?vue&type=style&index=0&id=6450a077&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports